<template>
  <v-container fluid align-start ma-0 pa-2 class="epms2030-main container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" 
          :useBtnList="useBtnList"
          :unUseBtnList="unUseBtnList"
          :btnKey="useBtnListKey"
          @btnSubmitPI="btnSubmitPI" @btnViewDetail="btnViewDetail"
          @btnRequestList="btnRequestList" @btnPipeListSaveAsExcel="btnPipeListSaveAsExcel"
        >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="12" class="px-1">
                <i-label :label="'Basic Information : '"/>
              </v-col>
            </v-row>

            <v-row dense class="form-layout">
              <v-col cols="12" class="pa-0">
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Quotation No</span>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters class="row__select-no">
                      <v-col cols="6">
                        <v-select
                          v-model="selectedQuot"
                          :items="quotList"
                          item-value="quotNo"
                          item-text="quotNo"
                          label="Select No"
                          return-object
                          single-line
                          outlined
                          dense
                          @change="quotNoChange"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Title</span>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field 
                      v-model="headerData.quotTitle" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Ship No, POR No</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.shipPorNo" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Start Date</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.startDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Finish Time</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.finishDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Delivery Condition</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.transCondDesc" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Payment Condition</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.payCondDesc" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Purchase Charger</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.buyerName" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>
                
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Recieve Date</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.receiveDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Submit Date</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.submitDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>PI Quotation / Target</span>
                  </v-col>
                  <v-col cols="3" class="d-flex align-center" style="padding: 0 7px;">
                    <span class="totAmount">{{ getNumComma(headerData.totAmount) }}</span>
                    <span class="totAmount px-2">/</span>
                    <span class="piAmount">{{ getNumComma(headerData.piAmount) }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="3" class="px-1">
                <i-label :label="'Detail Information : '"/>
              </v-col>
              <v-col cols="9" align="right" class="pa-1"  :style="headerData.receiveYn && headerData.receiveYn === 'Y' ? 'display: none;' : '' ">
                <span class="pa-1 subTitle2">[Not yet Received]</span>
              </v-col>
            </v-row>

            <v-row no-gutters class="form-layout">
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col cols="1" align="center" class="pt-1 formHeader">
                    <span>Delivery Condition</span>
                  </v-col>
                  <v-col cols="4" >
                    <template v-if="editGbn === '0'">
                      <v-select
                        v-model="transCond"
                        :items="transCondList"
                        item-value="code"
                        item-text="codeName"
                        return-object
                        single-line
                        outlined
                        dense
                        height="34" />
                    </template>
                    <template v-else>
                      <span class="px-3">
                        ******************
                      </span>
                    </template>
                  </v-col>
                  <v-col cols="1" align="center" class="pt-1 formHeader">
                    <span>Payment Condition</span>
                  </v-col>
                  <v-col cols="2">
                    <template v-if="editGbn === '0'">
                      <v-select
                        v-model="payCond"
                        :items="payCondList"
                        item-value="code"
                        item-text="codeName"
                        return-object
                        single-line
                        outlined
                        dense
                        height="34" />
                    </template>
                    <template v-else>
                      <span class="px-3">
                        ******************
                      </span>
                    </template>
                  </v-col>
                  <v-col cols="2" align="center" class="pt-1 pb-1 formHeader">
                    <span>Percent of Advance Payment</span>
                  </v-col>
                  <v-col cols="2">
                    <v-row no-gutters class="row__select-no">
                      <v-col cols="6">
                        <template v-if="editGbn === '0'">
                          <v-text-field 
                            v-model="headerData.payPct"
                            type="number"
                            oninput="javascript: this.value = this.value.replace(/[.|ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, ''); this.value = this.value > 100 ? 100 : this.value;"
                            dense 
                            outlined 
                            hide-details="auto"
                            :min="0"
                            :max="100"
                            height="32" />
                        </template>
                        <template v-else>
                          ***
                        </template>
                      </v-col>
                      <v-col cols="6" class="pl-2 pt-1" >
                        %
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters >
                  <v-col cols="1" align="center" class="pt-1 pb-1 formHeader">
                    <span>Remarks</span>
                  </v-col>
                  <v-col cols="9">
                    <template v-if="editGbn === '0'">
                      <v-text-field
                        v-model="remark" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable
                        height="32"
                      />
                    </template>
                    <template v-else>
                      <span class="px-3">
                        ******************************
                      </span>
                    </template>
                  </v-col>
                  <v-col cols="2">
                    <v-row no-gutters class="row__select-no" >
                      <v-col cols="6" align="center" class="pt-1 pb-1 formHeader">
                        <span>Money Unit: </span>
                      </v-col>
                      <v-col cols="6"  >
                        <template v-if="(headerData.submitYn && headerData.submitYn === 'Y')">
                          <span class="px-3">
                            *****
                          </span>
                        </template>
                        <template v-else>
                          <v-select
                            v-model="moneyUnit"
                            :items="moneyUnitList"
                            item-value="code"
                            item-text="codeName"
                            label="Select No"
                            return-object
                            single-line
                            outlined
                            dense
                            height="32" />
                        </template>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader formHeader2">
                    <span>Contract From Date</span>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field 
                      v-model="headerData.frDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader formHeader2">
                    <span>Contract To Date</span>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field 
                      v-model="headerData.toDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pt-1">
                <DxDataGrid id="epms2030" 
                  :ref="epms2030Ref"
                  class="hipGridHeight6_2"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="false"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                  :sorting="{ mode: 'none' }"
                >
                  <DxEditing :use-icons="true" mode="cell" />
                  <DxColumn data-field="no" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="shipNo" caption="Ship No" width="6%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="porNo" caption="POR No" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="matlSpec" caption="Material Specification" width="40%" data-type="string" alignment="left" :allow-editing="false"/>
                  <DxColumn data-field="reqQty" caption="Quantity" width="6%" data-type="string" alignment="right" :allow-editing="false"/>
                  <DxColumn data-field="matlUnit" caption="Unit" width="4%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn caption="Quotation Amount" data-type="string" alignment="center">
                    <DxColumn data-field="quotPrc" caption="Unit Price" width="8%" data-type="string" :format="format" alignment="right" :allow-editing="editGbn === '0'"
                                         :set-cell-value="quotPrcChanged"
                                         :editor-options="{ maxLength: 12 }"
                                         :cell-template="editGbn === '2' ? 'quotPrcTemplate' : ''" />
                    <DxColumn data-field="quotAmt" caption="Amount" width="8%" data-type="string" :format="format" alignment="right" :allow-editing="editGbn === '0'"
                                         :set-cell-value="quotAmtChanged"
                                         :editor-options="{ maxLength: 12 }"
                                         :cell-template="editGbn === '2' ? 'quotAmtTemplate' : ''"/>
                    <DxColumn data-field="quotVat" caption="VAT(%)" width="5%" data-type="number" alignment="right" :allow-editing="editGbn === '0'"
                                          :editor-options="{ min: 0, max: 99 }"
                                          :cell-template="editGbn === '2' ? 'quotVatTemplate' : ''" />
                  </DxColumn>
                  <template #quotPrcTemplate>
                    ************
                  </template>
                  <template #quotAmtTemplate>
                    ************
                  </template>
                  <template #quotVatTemplate>
                    **
                  </template>
                  <DxColumn caption="Transportation Fee" data-type="string" alignment="center" >
                    <DxColumn data-field="transAmt" caption="Amount" width="8%" data-type="string"  :format="format" alignment="right" :allow-editing="editGbn === '0'"
                                         :set-cell-value="transAmtChanged"
                                         :editor-options="{ maxLength: 10 }"
                                         :cell-template="editGbn === '2' ? 'transAmtTemplate' : ''" />
                    <DxColumn data-field="transVat" caption="VAT(%)" width="5%" data-type="number" alignment="right" :allow-editing="editGbn === '0'"
                                          :editor-options="{ min: 0, max: 99 }"
                                          :cell-template="editGbn === '2' ? 'transVatTemplate' : ''" />
                  </DxColumn>
                  <template #transAmtTemplate>
                    **********
                  </template>
                  <template #transVatTemplate>
                    **
                  </template>
                  <!-- <DxColumn data-field="govFee" width="8%" data-type="string" :format="format" alignment="right" header-cell-template="govHeaderTemplate" :allow-editing="editGbn === '0'"
                                        :set-cell-value="govFeeChanged"
                                        :editor-options="{ maxLength: 10 }"
                                        :cell-template="editGbn === '2' ? 'govCellTemplate' : ''" />
                  <template #govHeaderTemplate>
                    <div>Gov. Fee<br>(Price)</div>
                  </template>
                  <template #govCellTemplate>
                    **********
                  </template> -->
                  <DxPaging :enabled="true" />
                  <!-- <DxPager :visible="false" /> -->
                </DxDataGrid>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="3" class="px-1">
                <i-label :label="'File Information : '"/>
              </v-col>
            </v-row>
            <v-row v-for="row in 2" :key="'file__row_' + row" no-gutters style="height: 42px;">
              <v-col v-for="col in 2" :key="'file__row_' + row + '__col_' + col" cols="6" :style="{ 'border-width': `${row === 1 ? '1px' : '0px'} 1px 1px ${ col === 1? '1px' : '0px' }`, 'border-style': 'solid', 'border-color': 'gray' }">
                <template v-if="getFileGbn(getFileIdx(row, col)) === '1'">
                  <v-row no-gutters>
                    <span class="subTitle pa-2 pr-0">{{ getFileIdx(row, col) + '. ' }}</span>
                    <v-col cols="4">
                      <v-file-input class="pa-0" placeholder="File input" v-model="fileList[getFileIdx(row, col) - 1].fileName"></v-file-input>
                    </v-col>
                    <span class="subTitle pt-2 pl-4">Description :</span>
                    <v-col cols="full" class="pa-1">
                      <v-text-field 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable
                        height="32"
                        v-model="fileList[getFileIdx(row, col) - 1].fileDesc"
                      />
                    </v-col>
                  </v-row>
                </template>
                <template v-else-if="fileGbn1 === '3'">
                  <v-row no-gutters class="align-center">
                    <span class="subTitle pa-2">{{ getFileIdx(row, col) + '. ' }}</span>
                    <a @click.stop="ftpDownload(fileList[getFileIdx(row, col) - 1].linkPath, fileList[getFileIdx(row, col) - 1].fileDesc )">
                      {{ fileList[getFileIdx(row, col) - 1].fileDesc }}
                    </a>
                  </v-row>
                </template>
                <template v-else-if="fileGbn1 === '4'">
                  <v-row no-gutters>
                    <span class="subTitle pa-2 pr-0">{{ `${getFileIdx(row, col) + '. ' }${fileList[getFileIdx(row, col) - 1].fileDesc ? fileList[getFileIdx(row, col) - 1].fileDesc : ''}${fileList[getFileIdx(row, col) - 1].fileName ? '(' + fileList[getFileIdx(row, col) - 1].fileName + ')' : ''}` }}</span>
                  </v-row>
                </template>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { getNumComma, toNum } from '@/utils/common.js'
import notify from 'devextreme/ui/notify'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getSubmitFile, getQuotNoList, getRequestHead, getSubmitDetail, getPipeQuotYn, ftpDownload } from '@/api/view/hip/common/common'
import { epms7010xls } from '@/api/view/hip/common/commonXls'
import { submitQuot } from '@/api/view/hip/2/epms2020'

export default {
  name: 'epms2030',
  mixins: [baseview, BaseDataGrid],
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epms2030Ref: 'epms2030Ref',
      selectedQuot: null,
      headerData: {
        receiveYn: 'N',
        submitYn: 'N',
        printYn: 'N',
        totAmount: 0,
        piAmount: 0
      },
      quotList: [],
      dataList: [],
      useBtnListKey: 0,
      unUseBtnList: [],
      useBtnList: ['btnSubmitPI', 'btnViewDetail', 'btnRequestList', 'btnPipeListSaveAsExcel'],
      useBtnListTemp: ['btnSubmitPI', 'btnViewDetail', 'btnRequestList', 'btnPipeListSaveAsExcel'],
      transCondList: [],
      transCond: null,
      payCondList: [],
      payCond: null,
      moneyUnitList: [],
      moneyUnit: null,
      remark: '',
      isHVSip: false,
      editGbn: '0', // 0, 1, 2
      format: '#,##0.############',
      fileList: [
        { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
        { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
        { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
        { fileDesc: null, fileName: null, fileSeq: null, linkPath: null }
      ],
      fileGbn1: '0',
      fileGbn2: '0',
      fileGbn3: '0',
      fileGbn4: '0'
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms2030Ref)
    },
  },
  methods: {
    initData() {
      this.headerData = {
        receiveYn: 'N',
        submitYn: 'N',
        printYn: 'N',
        totAmount: 0,
        piAmount: 0
      }
      this.dataList = []
      this.unUseBtnList = []
      this.useBtnList = [],
      this.payCond = this.payCondList[0]
      this.transCond = this.transCondList[0]
      this.moneyUnit = this.moneyUnitList[0]
      this.remark = ''
      this.editGbn = '0'
      this.fileList = [
        { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
        { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
        { fileDesc: null, fileName: null, fileSeq: null, linkPath: null },
        { fileDesc: null, fileName: null, fileSeq: null, linkPath: null }
      ]
      this.fileGbn1 = this.fileGbn2 = this.fileGbn3 = this.fileGbn4 = '0'
    },
    setHVSIp() {
      const logIP = this.$store.state.user.userIp
      const userGrd = this.$store.state.user.userGrd
      const userId = this.$store.state.user.userId

      if (('192.168.46.5' === logIP || '192.168.48.' === logIP.substr(0, 11) || '192.168.50.' === logIP.substr(0, 11) || '192.168.51.' === logIP.substr(0, 11)
          || '192.168.52.' === logIP.substr(0, 11) || '192.168.53.' === logIP.substr(0, 11) || '192.168.54.' === logIP.substr(0, 11)
          || '192.168.55.' === logIP.substr(0, 11) || '192.168.56.' === logIP.substr(0, 11) || '192.168.57.' === logIP.substr(0, 11)
          || '192.168.58.' === logIP.substr(0, 11) || '192.168.61.' === logIP.substr(0, 11) || '192.168.69.' === logIP.substr(0, 11))
          && !'A' === userGrd && !'11246' === userId && !'10403' === userId && !'11272' === userId && !'10252' === userId)
      {
        this.isHVSip = true
      }
    },
    async getCmmCd() {
      await getCmChildCode({
        code: '',
        codegr: '',
        prtCode: 'TRANS_COND',
        userFlag: 'Y'
      }).then(res => {
        this.transCondList = res.list
        this.transCond = this.transCondList[0]
      })

      await getCmChildCode({
        code: '',
        codegr: '',
        prtCode: 'PAY_COND',
        userFlag: 'Y'
      }).then(res => {
        this.payCondList = res.list
        this.payCond = this.payCondList[0]
      })

      await getCmChildCode({
        code: '',
        codegr: '',
        prtCode: 'MNY_UNIT',
        userFlag: 'Y'
      }).then(res => {
        this.moneyUnitList = res.list
        this.moneyUnit = this.moneyUnitList[0]
      })
    },
    async getQuotNoList() {
      const param = {
        makerCd: this.$store.state.user.makerCd,
        quotStep: 'B',
        quotDiv: 'L',
        userId: this.$store.state.user.userId,
      }

      await getQuotNoList(param).then(res => {
        // console.log('res', res)
        
        const setVal = res.list.find(element => element.quotNo === this.$route.params.quotNo)

        this.quotList = res.list
        this.selectedQuot = setVal
        this.quotNoChange(setVal)
      })
    },
    quotNoChange(e) {
      if(e) {
        this.getQuotData()
      }
    },
    async getQuotData() {
      try {
        this.initData()
        this.openLoading('searching')

        const param = {
          quotNo: this.selectedQuot.quotNo,
          quotStep: this.selectedQuot.quotStep,
          makerCd: this.$store.state.user.makerCd,
          quotDiv: 'L'
        }

        await getRequestHead(param).then(res => {
          // console.log('headRes', res)

          if(res.list.length > 0) {
            this.headerData = res.list[0]

            this.headerData.totAmount = 0
            this.headerData.payPct = 0

            const transCd = this.$_.filter(this.transCondList, cond => {
              return cond.code === this.headerData.transCond
            })

            if(transCd.length > 0) {
              this.transCond = transCd[0]
            }

            const payCd = this.$_.filter(this.payCondList, cond => {
              return cond.code === this.headerData.payCond
            })

            if(payCd.length > 0) {
              this.payCond = payCd[0]
            }

            if(!this.headerData.submitYn || this.headerData.submitYn === 'N') {
              this.editGbn = '0'
            } else if(!this.headerData.printYn || this.headerData.printYn === 'N') {
              this.editGbn = '1'
            } else {
              this.editGbn = '2'
            }
          }
        })

        await getSubmitDetail(param).then(res => {
          // console.log('submitDetailRes', res)

          let data = res.list
          for(let i = 0; i < data.length; i++){
            data[i].id = data[i].no = i + 1
            data[i].porNo = data[i].porNo + '-' + data[i].porSeq
            data[i].reqQty = Number(data[i].reqQty)
            data[i].quotPrc = Number(data[i].quotPrc)
            data[i].quotAmt = Number(data[i].quotAmt)
            data[i].quotVat = Number(data[i].quotVat)
            data[i].transAmt = Number(data[i].transAmt)
            data[i].transVat = Number(data[i].transVat)
            data[i].govFee = Number(data[i].govFee)
            data[i].wrtMonth = Number(data[i].wrtMonth)
          }
          this.dataList = data
        })

        await getPipeQuotYn(param).then(res => {
          // console.log('pipeQuotYnRes', res)

          this.headerData.pipeYn = res.list[0].yn
        })

        await getSubmitFile(param).then(res => {
          // console.log('fileRes', res)

          for(let i = 0; i < res.list.length; i++) {
            this.fileList[i].fileName = res.list[i].fileName
            this.fileList[i].fileDesc = res.list[i].fileDesc
            this.fileList[i].fileSeq = res.list[i].fileSeq
            this.fileList[i].linkPath = res.list[i].linkPath
          }

          if(!this.headerData.submitYn || this.headerData.submitYn === 'N') {
            this.fileGbn1 = this.fileGbn2 = this.fileGbn3 = this.fileGbn4 = '1'
          } else {
            for(let i = 0; i < this.fileList.length; i++) {
              if(!this.fileList[i].fileName) {
                this[`fileGbn${i + 1}`] = '2'
                continue
              }

              if(!this.headerData.printYn || this.headerData.printYn === 'N') {
                this[`fileGbn${i + 1}`] = '3'
                continue
              }

              this[`fileGbn${i + 1}`] = '4'
            }
          }

          // console.log('this.fileGbn1', this.fileGbn1)
          // console.log('this.fileGbn2', this.fileGbn2)
          // console.log('this.fileGbn3', this.fileGbn3)
          // console.log('this.fileGbn4', this.fileGbn4)
        })

        this.setBtnList()
      } finally {
        this.endLoading()
      }
    },
    getFileGbn(gbn) {
      return this['fileGbn' + gbn]
    },
    getFileIdx(row, col) {
      return row*col  + (col < row ? row - 1 : 0)
    },
    setBtnList() {
      let btnTemp = this.$_.cloneDeep(this.useBtnListTemp)

      // console.log('this.headerData.submitYn', this.headerData.submitYn)
      // console.log('this.headerData.pipeYn', this.headerData.pipeYn)

      if(this.headerData.submitYn === 'Y') {
        this.unUseBtnList.push('btnSubmitPI')
      }

      if(this.headerData.pipeYn !== 'Y') {
        btnTemp = this.$_.filter(btnTemp, function(btnTemp) {
          return btnTemp !== 'btnPipeListSaveAsExcel'
        })
      }

      // console.log('btnTemp', btnTemp)

      this.useBtnList = btnTemp
      this.useBtnListKey++
    },
    transAmtChanged(newData , value , currentRowData) {
      let val = toNum(value)
      val = val >= 0 ? Math.abs(val) : 0
      newData.transAmt = val
    },
    govFeeChanged(newData , value , currentRowData) {
      let val = toNum(value)
      val = val >= 0 ? Math.abs(val) : 0
      newData.govFee = val
    },
    quotPrcChanged(newData , value , currentRowData) {
      let val = toNum(value)
      val = val >= 0 ? Math.abs(val) : 0
      newData.quotPrc = val
      newData.quotAmt = Math.ceil(val * Number(currentRowData.reqQty) * 100) / 100

      this.fncCalcTotal(newData.quotAmt, currentRowData.id)
    },
    quotAmtChanged(newData , value , currentRowData) {
      let val = toNum(value)
      val = val >= 0 ? Math.abs(val) : 0
      newData.quotAmt = val
      if(val != 0 && Number(currentRowData.reqQty)  !== 0) {
        newData.quotPrc = Math.ceil(val / Number(currentRowData.reqQty) * 100) / 100
      } else {
        newData.quotPrc = 0
      }

      this.fncCalcTotal(newData.quotAmt, currentRowData.id)
    },
    async btnSubmitPI() {
      const vm = this

      await this.gridInstance.saveEditData()
      // this.fncCalcTotal()

      const hvsIP = this.isHVSip
      const makerCd = this.$store.state.user.makerCd

      if(hvsIP) {
        this.vToastify(this.$t('Warning : You access to HiP System at the HVS Company.<br>You cannot submit the quotation in the HVS.<br>Call IT Department.(2487, 2496, 2497).'), 'warn')
        return
      } else if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no quotation no.'), 'warn')
        return
      } else if(this.headerData.submitYn === 'Y') {
        return
      } else if(this.headerData.receiveYn !== 'Y') {
        this.vToastify(this.$t('Not yet Received'), 'warn')
        return
      }

      const totAmt = this.headerData.totAmount
      if(totAmt * 1 === 0) {
        if(!this.remark) {
          this.vToastify(this.$t('Cannot submit.<br>Quotation Amount is 0 and Remarks is null.'), 'warn')
          return
        }
      }

      for(let i = 0; i < this.dataList.length; i++) {
        const lastAmt = toNum(this.dataList[i].lastAmt)
        const quotAmt = toNum(this.dataList[i].quotAmt)

        if(lastAmt >= 0 && lastAmt < quotAmt) {
          this.vToastify(this.$t('This submit amount is greater than previous amount.'), 'warn')
          // this.gridInstance.editCell(i, 'quotAmt')
          return
        }

        // console.log('lastAmt', lastAmt)
        // console.log('quotAmt', quotAmt)
      }

      let prms = true
      if(makerCd !== '90263' && makerCd !== '95987') {
        let vat
        let cnt = 0
        for(let i = 0; i < vm.dataList.length; i++) {
          vat = this.dataList[i].quotVat * 1
          if(vat === 0) {
            cnt++
            break
          }
        }

        if(cnt > 0) {
          await new Promise(function(resolve, reject) {
            vm.vToastifyPrompt(
              vm.$t('Some item\'s VAT is 0.<br>Continue?'),
              'info',
              current => {
                prms = true
                resolve()
              },
              current => {
                prms = false
                resolve()
              },
              false
            )
          })
        }
      }

      if(!prms) {
        return
      }

      for(let i = 0; i < this.fileList.length; i++) {
        if(this.fileList[i].fileName && !this.fileList[i].fileDesc) {
          this.vToastify(this.$t(`Input File${i+1} description.`), 'warn')
          return
        }
      }

      for (let i = 0; i < this.dataList.length; i++) {              
          this.dataList[i].porNo = this.dataList[i].porNo.substr(0, 8)                              
          }

      this.vToastifyPrompt(
        this.$t('Do you want to submit the P/I?'),
        'info',
        current => {
          const formData = new FormData()

          this.headerData.remark = this.remark
          this.headerData.moneUnit = this.moneyUnit.code
          this.headerData.userId = this.$store.state.user.userId
          this.headerData.userIp = this.$store.state.user.userIp
          formData.append('masterData', JSON.stringify(this.headerData))
          formData.append('detailData', JSON.stringify(this.dataList))

          for(let i = 0; i < this.fileList.length; i++) {
            if(this.fileList[i].fileName) {
              formData.append('files', this.fileList[i].fileName)
              formData.append('fileDescs', this.fileList[i].fileDesc)
            }
          }

          // console.log('masterData', formData.getAll('masterData'))
          // console.log('detailData', formData.getAll('detailData'))
          // console.log('files', formData.getAll('files'))
          // console.log('fileDescs', formData.getAll('fileDescs'))

          this.openLoading()
          submitQuot(formData).then(res => {
            // console.log('submitQuotRes', res)

            const result = res.body
            if(result === 'OK') {
              this.quotNoChange(this.selectedQuot)
              notify(this.$t('P/I Quotation Submit is completed.'), 'success', 3000)
            } else {
              this.vToastify(this.$t(result), 'warn')
            }
          }).catch(error => {
            this.vToastify(error, 'warn')
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        false
      )
    },
    fncCalcTotal(currVal, id) {
      let total = 0

      for(let i = 0; i < this.dataList.length; i++) {
        if(this.dataList[i].id !== id) {
          total += Number(this.dataList[i].quotAmt)
        }
      }
      total += currVal

      this.headerData.totAmount = getNumComma(total)
      this.headerData = JSON.parse(JSON.stringify(this.headerData))
    },
    btnViewDetail() {
      this.$router.push({
        name: 'epms2010',
        params: {
          quotNo: this.selectedQuot ? this.selectedQuot.quotNo : ''
        }
      })
    },
    btnRequestList() {
      this.$router.push({
        name: 'epms2000'
      })
    },
    btnPipeListSaveAsExcel() {
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('Quotation number is not selected.'), 'warn')
        return
      }

      const param = {
        quotNo: this.selectedQuot.quotNo,
        makerCd: this.$store.state.user.makerCd,//this.headerData.makerCd,
        quotStep: this.headerData.quotStep
      }

      epms7010xls(param)
    },
    getNumComma(val) {
      return getNumComma(val)
    },
    ftpDownload(filePath, fileName) {
      this.openLoading()
      ftpDownload(filePath, fileName).finally(() => {
        this.endLoading()
      })
    }
  },
  mounted() {
    this.setHVSIp()
    this.getCmmCd()
    this.getQuotNoList()
  }
}
</script>

<style lang="scss" scoped>
$redBtn: #FF0000;

.form-layout::v-deep .col {
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: gray;
  
  * {
    border: 0px none !important;
  }

  .row:not(.row__select-no) {
    border-width: 0 0 1px 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }

  .col:not(.quotNo) {
    border-width: 0 1px 0 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }
}
.formHeader {
   background-color: rgb(223, 227, 213);
   font-weight: bold;
   // border: 1px solid gray;
   color: black;
   font-size: 9pt;
 }

.formHeader2 {
   background-color: rgb(214, 243, 247);
 }

.subTitle {
  font-weight: bold;
  color: black;
}
.subTitle2 {
  font-weight: bold;
  color: red;
}
.quotNo {
  font-weight: bold;
  border: 1px solid gray;
  border-bottom: 0px;
  color: #0000FF;
  font-size: 9pt;
}

::v-deep {
  [role=btnSubmitPI] {
    :not([disabled=disabled]) {
      .v-btn__content {
        div, i {
          color: #{$redBtn} !important;
        }
      }
    }
  }
}

.totAmount, .piAmount {
  font-size: 13px;
  font-family: 'Roboto', sans-serif;
  color: black;
}

.piAmount {
  color: red;
}
</style>